"use strict";
/**
 * Wrapper around the browser-specific implementation of the path module.
 *
 * @packageDocumentation
 * @internal
 * @hidden
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @internal
 * @hidden
 */

var path_1 = require("path");

Object.defineProperty(exports, "joinPath", {
  enumerable: true,
  get: function get() {
    return path_1.join;
  }
});